export default __webpack_public_path__ + "static/media/opensea.0c1787cb.svg";